import * as React from 'react';
import { TeamMemberFullNameContainer, TeamMemberFullNameContent } from './components';

export const TeamMemberFullName = () => (
  <TeamMemberFullNameContainer>
    <TeamMemberFullNameContent />
  </TeamMemberFullNameContainer>
);
